// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inventory-details thead.v-data-table-header > tr > th > div[data-v-3b6aadd0] {\n  display: inline-block;\n  width: 80%;\n}\n", ""]);
// Exports
module.exports = exports;
